var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVioletGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1286,
    viewBox: "0 0 1920 1286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_230_24415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1675.65 672.039C1675.65 773.744 1712.24 917.259 1578.27 982.582C1451.06 1044.61 1158.26 1031.05 967.873 1031.05C797.766 1031.05 449.422 1053.5 327.362 1002.78C168.939 936.938 260.098 784.03 260.098 672.039C260.098 570.334 193.387 372.951 327.362 307.628C454.572 245.603 777.489 266.614 967.873 266.614C1158.26 266.614 1476.52 220.301 1603.73 282.325C1737.71 347.648 1675.65 570.334 1675.65 672.039Z",
    fill: "url(#paint0_linear_230_24415)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_230_24415",
    x: -16,
    y: 0,
    width: 1956,
    height: 1286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_230_24415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_24415",
    x1: 493.21,
    y1: 354.748,
    x2: 1446.47,
    y2: 1132.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D505FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletGlow);
export default __webpack_public_path__ + "static/media/VioletGlow.248473548f187f4e3a9e945500e240de.svg";
export { ForwardRef as ReactComponent };